// UK postcode area code → place name (source: Eureka telco UK data dictionary).
// Used to display real place names instead of postcode abbreviations in all
// geography charts, dropdowns and tables.
export const POSTCODE_NAMES = {
  "AB": "Aberdeen",
  "AL": "St Albans",
  "B": "Birmingham",
  "BA": "Bath",
  "BB": "Blackburn",
  "BD": "Bradford",
  "BH": "Bournemouth",
  "BL": "Bolton",
  "BN": "Brighton",
  "BR": "Bromley",
  "BS": "Bristol",
  "BT": "Belfast",
  "CA": "Carlisle",
  "CB": "Cambridge",
  "CF": "Cardiff",
  "CH": "Chester",
  "CM": "Chelmsford",
  "CO": "Colchester",
  "CR": "Croydon",
  "CT": "Canterbury",
  "CV": "Coventry",
  "CW": "Crewe",
  "DA": "Dartford",
  "DD": "Dundee",
  "DE": "Derby",
  "DG": "Dumfries",
  "DH": "Durham",
  "DL": "Darlington",
  "DN": "Doncaster",
  "DT": "Dorchester",
  "DY": "Dudley",
  "E": "East London",
  "EC": "East Central London",
  "EH": "Edinburgh",
  "EN": "Enfield",
  "EX": "Exeter",
  "FK": "Falkirk",
  "FY": "Blackpool",
  "G": "Glasgow",
  "GL": "Gloucester",
  "GU": "Guildford",
  "GY": "Guernsey",
  "HA": "Harrow",
  "HD": "Huddersfield",
  "HG": "Harrogate",
  "HP": "Hemel Hempstead",
  "HR": "Hereford",
  "HS": "Hebrides",
  "HU": "Hull",
  "HX": "Halifax",
  "IG": "Ilford",
  "IM": "Isle of Man",
  "IP": "Ipswich",
  "IV": "Inverness",
  "JE": "Jersey",
  "KA": "Kilmarnock",
  "KT": "Kingston upon Thames",
  "KW": "Kirkwall",
  "KY": "Kirkcaldy",
  "L": "Liverpool",
  "LA": "Lancaster",
  "LD": "Llandrindod Wells",
  "LE": "Leicester",
  "LL": "Llandudno",
  "LN": "Lincoln",
  "LS": "Leeds",
  "LU": "Luton",
  "M": "Manchester",
  "ME": "Medway",
  "MK": "Milton Keynes",
  "ML": "Motherwell",
  "N": "North London",
  "NE": "Newcastle upon Tyne",
  "NG": "Nottingham",
  "NN": "Northampton",
  "NP": "Newport",
  "NR": "Norwich",
  "NW": "North West London",
  "OL": "Oldham",
  "OX": "Oxford",
  "PA": "Paisley",
  "PE": "Peterborough",
  "PH": "Perth",
  "PL": "Plymouth",
  "PO": "Portsmouth",
  "PR": "Preston",
  "RG": "Reading",
  "RH": "Redhill",
  "RM": "Romford",
  "S": "Sheffield",
  "SA": "Swansea",
  "SE": "South East London",
  "SG": "Stevenage",
  "SK": "Stockport",
  "SL": "Slough",
  "SM": "Sutton",
  "SN": "Swindon",
  "SO": "Southampton",
  "SP": "Salisbury",
  "SR": "Sunderland",
  "SS": "Southend-on-Sea",
  "ST": "Stoke-on-Trent",
  "SW": "South West London",
  "SY": "Shrewsbury",
  "TA": "Taunton",
  "TD": "Galashiels",
  "TF": "Telford",
  "TN": "Tunbridge Wells",
  "TQ": "Torquay",
  "TR": "Truro",
  "TS": "Teesside",
  "TW": "Twickenham",
  "UB": "Uxbridge",
  "Unknown": "Unknown",
  "W": "West London",
  "WA": "Warrington",
  "WC": "West Central London",
  "WD": "Watford",
  "WF": "Wakefield",
  "WN": "Wigan",
  "WR": "Worcester",
  "WS": "Walsall",
  "WV": "Wolverhampton",
  "XX": "Non-geographic",
  "YO": "York",
  "ZE": "Shetland",
};

// Display helper — falls back to the raw code for unmapped values
export const geoName = (code) => POSTCODE_NAMES[code] || code;
